import { all, fork } from "redux-saga/effects";
import bestPriceCoins from "./bestPriceCoins";
import tokenStore from "./tokenStore";
export default function* root() {
  yield all([fork(bestPriceCoins), fork(tokenStore)]);
}
